import { useQuery } from "@tanstack/react-query";

import { getMaintenanceNotifications } from "../../services/notificationService";

// const fakeAnnouncement = {
//   data: {
//     message:
//       'auth:Hello, this is a fake maintenance announcement for testing purposes. <link to="https://google.com">Google</link> **Bold Text** __Underlined Text__ _Italic Text_ ~~Strikethrough Text~~',
//     startTime: "2026-07-01T00:00:00Z",
//     endTime: "2026-07-31T23:59:59Z",
//     id: "fake-announcement-id",
//   },
// };

// const fakeAPI = () =>
//   new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(fakeAnnouncement);
//     }, 1000);
//   });

const useGetMaintanceAnnouncement = () => {
  const query = useQuery({
    queryKey: ["maintenanceAnnouncement"],
    queryFn: getMaintenanceNotifications, // Replace with getMaintenanceNotifications for real API call
    refetchInterval: 15 * 60 * 1000, // Refetch every 15 minute
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    meta: {
      disabledGlobalToast: true,
    },
  });

  return query;
};

export default useGetMaintanceAnnouncement;
